export const SET_CODIGO_BENEFICIOS = 'BENEFICIO/SET_CODIGO_BENEFICIOS';
export const SET_CODIGO_BENEFICIO = 'BENEFICIO/SET_CODIGO_BENEFICIO';
export const RESET_CODIGO_BENEFICIO = 'BENEFICIO/RESET_CODIGO_BENEFICIO';
